/**
 * IcyImage
 * @author frontMoment
 */

import ImageComponent from './ImageComponent'

export default {
  install: function(Vue) {
    Vue.component('ImageComponent', ImageComponent)
  }
}
